const translations = {
  // Navbar
  'nav.home': 'Accueil',
  'nav.services': 'Services',
  'nav.track': 'Suivre un colis',
  'nav.about': 'À propos',
  'nav.contact': 'Contact',
  'nav.trackNow': 'Suivre maintenant',

  // Footer
  'footer.tagline': 'Approuvé par des milliers d\'entreprises dans le monde pour un suivi fiable et en temps réel des expéditions.',
  'footer.quickLinks': 'Liens rapides',
  'footer.contactUs': 'Contactez-nous',
  'footer.globalNumbers': 'Numéros mondiaux',
  'footer.uk': 'Royaume-Uni',
  'footer.usa': 'États-Unis',
  'footer.canada': 'Canada',
  'footer.allRightsReserved': 'Tous droits réservés.',
  'footer.privacy': 'Politique de confidentialité',
  'footer.terms': 'Conditions d\'utilisation',
  'footer.cookies': 'Politique des cookies',

  // Hero
  'hero.badge': 'APPROUVÉ PAR PLUS DE 50 000 ENTREPRISES DANS LE MONDE',
  'hero.headline1': 'Livrer le monde,',
  'hero.headline2': 'À temps',
  'hero.subtext': 'Suivi des expéditions en temps réel par air, terre et mer. Sachez exactement où se trouve votre cargaison — chaque kilomètre du voyage.',
  'hero.placeholder': 'Entrez le numéro de suivi (ex. SWT-2024-001847)',
  'hero.trackBtn': 'Suivre l\'expédition',
  'hero.tryLabel': 'Essayez :',
  'hero.scroll': 'Faire défiler pour explorer',
  'hero.stat1': 'Colis livrés',
  'hero.stat2': 'Pays desservis',
  'hero.stat3': 'Taux de ponctualité',
  'hero.stat4': 'Assistance 24h/24',

  // Services Section
  'services.badge': 'Niveaux de service',
  'services.title1': 'Choisissez votre',
  'services.title2': 'Forfait d\'expédition',
  'services.subtitle': 'De l\'expédition économique à la livraison prioritaire le jour même — nous avons le bon service pour chaque envoi.',
  'services.perShipment': 'Par envoi',
  'services.monthlyPlan': 'Forfait mensuel',
  'services.monthlySaving': 'Les forfaits mensuels permettent d\'économiser jusqu\'à 35% par rapport aux tarifs à l\'envoi',
  'services.enterprise.title': 'Vous avez besoin d\'un plan entreprise personnalisé ?',
  'services.enterprise.desc': 'Remises sur volume, gestionnaires de compte dédiés et SLA personnalisés pour les expéditeurs à haute fréquence.',
  'services.enterprise.cta': 'Contacter les ventes',
  'services.perKg': 'par kg',
  'services.perMo': '/mois',
  'services.economy.name': 'Économique',
  'services.economy.tagline': 'Expédition économique',
  'services.economy.cta': 'Commencer gratuitement',
  'services.economy.time': '5–7 jours ouvrés',
  'services.standard.name': 'Standard',
  'services.standard.tagline': 'Livraison quotidienne fiable',
  'services.standard.cta': 'Choisir Standard',
  'services.standard.time': '2–3 jours ouvrés',
  'services.express.name': 'Express',
  'services.express.tagline': 'Livraison accélérée',
  'services.express.cta': 'Choisir Express',
  'services.express.time': 'Jour ouvré suivant',
  'services.express.badge': 'Le plus populaire',
  'services.priority.name': 'Prioritaire',
  'services.priority.tagline': 'Service haut de gamme le jour même',
  'services.priority.cta': 'Choisir Prioritaire',
  'services.priority.time': 'Même jour (fenêtre de 2h)',
  'services.priority.badge': 'Premium',
  'services.feat.basicTracking': 'Suivi basique du colis',
  'services.feat.emailNotif': 'Notification de livraison par e-mail',
  'services.feat.20kg': 'Jusqu\'à 20 kg',
  'services.feat.insurance100': 'Assurance standard (100 $)',
  'services.feat.liveMap': 'Suivi cartographique en direct',
  'services.feat.priority': 'Traitement prioritaire',
  'services.feat.smsAlerts': 'Alertes SMS et push',
  'services.feat.signature': 'Signature à la livraison',
  'services.feat.fullTracking': 'Suivi complet en temps réel',
  'services.feat.emailSms': 'Notifications e-mail + SMS',
  'services.feat.50kg': 'Jusqu\'à 50 kg',
  'services.feat.insurance500': 'Assurance standard (500 $)',
  'services.feat.dedicatedDriver': 'Chauffeur dédié',
  'services.feat.emailSmsPush': 'E-mail + SMS + alertes push',
  'services.feat.100kg': 'Jusqu\'à 100 kg',
  'services.feat.insurance2000': 'Assurance premium (2 000 $)',
  'services.feat.routeOpt': 'Optimisation d\'itinéraire',
  'services.feat.unlimitedWeight': 'Poids illimité',
  'services.feat.insurance10000': 'Assurance complète (10 000 $)',
  'services.feat.dedicatedDriverAssigned': 'Chauffeur dédié assigné',

  // Tracking Page
  'track.title': 'Suivre votre expédition',
  'track.subtitle': 'Entrez votre numéro de suivi pour voir le statut en temps réel et les mises à jour de livraison.',
  'track.placeholder': 'ex. SWT-2024-001847',
  'track.scanBtn': 'Scanner le code',
  'track.trackBtn': 'Suivre',
  'track.privacy': 'Votre numéro de suivi est privé — seul vous pouvez voir les détails de votre expédition',
  'track.enter.title': 'Entrez votre numéro de suivi',
  'track.enter.desc': 'Votre numéro de suivi unique vous a été envoyé par e-mail lors de la création de votre expédition. Il ressemble à',
  'track.feature1': 'Mises à jour en temps réel',
  'track.feature2': 'Suivi cartographique en direct',
  'track.feature3': 'Alertes instantanées',
  'track.notFound.title': 'Aucune expédition trouvée',
  'track.notFound.desc': 'Nous n\'avons pas trouvé d\'expédition avec le numéro de suivi',
  'track.notFound.hint': 'Veuillez vérifier le numéro ou contacter',
  'track.notFound.support': 'l\'assistance',
  'track.found.title': 'Expédition trouvée',
  'track.found.private': 'Privé pour vous',
  'track.found.viewDetails': 'Voir tous les détails',
  'track.found.estDelivery': 'Livraison estimée',
  'track.found.progress': 'Progression',

  // About Page
  'about.badge': 'NOTRE HISTOIRE',
  'about.headline': 'Construit pour le monde moderne du commerce',
  'about.subtext': 'Fondé en 2014, SwiftTrack a démarré avec une mission simple : rendre l\'expédition aussi simple qu\'un envoi d\'e-mail. Aujourd\'hui, nous transportons des millions de colis dans 180+ pays.',
  'about.stat.founded': 'Année de fondation',
  'about.stat.countries': 'Pays desservis',
  'about.stat.deliveries': 'Livraisons/an',
  'about.stat.partners': 'Partenaires commerciaux',
  'about.mission.badge': 'NOTRE MISSION',
  'about.mission.title1': 'Relier les personnes,',
  'about.mission.title2': 'Livrer les possibilités',
  'about.mission.p1': 'Nous croyons que chaque envoi transporte plus que des marchandises. Il transporte la confiance, des relations et la promesse de quelque chose de mieux à l\'autre bout. Notre plateforme technologique garantit que chaque colis — d\'un cadeau d\'anniversaire manuscrit à un dispositif médical vital — arrive exactement quand et où il le devrait.',
  'about.mission.p2': 'Nous combinons le suivi GPS de pointe, l\'optimisation des itinéraires par IA et un réseau de transporteurs vérifiés pour vous offrir l\'expérience d\'expédition la plus fiable et transparente au monde.',
  'about.values.title': 'Les valeurs qui nous animent',
  'about.values.subtitle': 'Notre culture repose sur quatre piliers qui guident chacune de nos décisions.',
  'about.value1.title': 'Fiabilité',
  'about.value1.desc': '99,7 % de livraisons à l\'heure, soutenues par une surveillance en temps réel et une résolution proactive des problèmes.',
  'about.value2.title': 'Transparence',
  'about.value2.desc': 'Visibilité totale à chaque étape. Pas de frais cachés, pas de surprises — juste une communication honnête et claire.',
  'about.value3.title': 'Durabilité',
  'about.value3.desc': 'Flotte à compensation carbone et itinéraires optimisés pour minimiser notre empreinte environnementale.',
  'about.value4.title': 'Client d\'abord',
  'about.value4.desc': 'Chaque décision que nous prenons commence par une question : comment cela améliore-t-il les choses pour nos clients ?',
  'about.team.title1': 'Rencontrez notre',
  'about.team.title2': 'Direction',
  'about.team.subtitle': 'Des opérateurs et technologues expérimentés unis par la passion de la logistique mondiale.',

  // Contact Page
  'contact.title': 'Nous contacter',
  'contact.subtitle': 'Questions, devis ou commentaires — notre équipe est prête à vous aider 24h/24.',
  'contact.info.title': 'Nous sommes là pour vous',
  'contact.info.desc': 'Contactez-nous par n\'importe quel canal. Temps de réponse moyen inférieur à 3 minutes pour le chat en direct, inférieur à 2 heures pour l\'e-mail.',
  'contact.info.address': 'Adresse',
  'contact.info.phone': 'Téléphone',
  'contact.info.email': 'E-mail',
  'contact.info.hours': 'Heures d\'assistance',
  'contact.info.hoursVal': '24h/24, 7j/7 — Nous ne fermons jamais',
  'contact.form.title': 'Envoyez-nous un message',
  'contact.form.name': 'Nom complet',
  'contact.form.email': 'Adresse e-mail',
  'contact.form.phone': 'Téléphone',
  'contact.form.subject': 'Sujet',
  'contact.form.subjectPlaceholder': 'Sélectionnez un sujet',
  'contact.form.subjectTrack': 'Aide au suivi des expéditions',
  'contact.form.subjectQuote': 'Demander un devis',
  'contact.form.subjectEnterprise': 'Solutions entreprise',
  'contact.form.subjectBilling': 'Demande de facturation',
  'contact.form.subjectOther': 'Autre',
  'contact.form.message': 'Message',
  'contact.form.send': 'Envoyer le message',
  'contact.form.sending': 'Envoi en cours...',
  'contact.form.error': 'Une erreur s\'est produite. Veuillez réessayer.',
  'contact.sent.title': 'Message envoyé !',
  'contact.sent.desc': 'Nous vous répondrons dans les 2 heures.',
  'contact.sent.another': 'Envoyer un autre',
};

export default translations;
